const isFunction = (value) => typeof value === "function";

export { isFunction };
